
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.676 37.014h-13.34a3.334 3.334 0 01-3.334-3.334V10.337a3.334 3.334 0 013.335-3.335h21.676a3.334 3.334 0 013.334 3.335V18.5M15 19.4h5M23 19.4h6M15 13h7M29 13h-4","stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M17.134 26c-.888 1.177-1.75 2.48-2.08 3.94-.155.681-.02 1.864 1 1.444.307-.126 1.814-1.744 1.954-1.604.238.238.106.58.611.469.475-.105.867-.491 1.215-.802.434-.387.957-.099 1.525-.048 1.002.09 2.078.712 3.05.429","stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round"}}),_c('rect',{attrs:{"x":"28","y":"32.327","width":"11.507","height":"3.257","rx":"1.628","transform":"rotate(-45 28 32.327)","fill":"#fff"}}),_c('rect',{attrs:{"width":"2.664","height":"3.257","rx":"1.332","transform":"scale(-1 1) rotate(45 -45.937 -34.742)","fill":"#F4A226"}}),_c('path',{attrs:{"d":"M30.995 34.834h-2.33a.656.656 0 01-.665-.666v-2.33c0-.166.083-.332.166-.416l7.655-7.654c.25-.25.665-.25.915 0s.25.666 0 .915l-7.405 7.405v1.498h1.498l7.405-7.405c.25-.25.665-.25.915 0s.25.665 0 .915l-7.655 7.654c-.166 0-.332.084-.499.084z","fill":"#363636"}}),_c('path',{attrs:{"d":"M38.566 27.262a.636.636 0 01-.416-.166l-2.33-2.33a.636.636 0 01-.166-.416c0-.166.084-.332.167-.416l1.497-1.497a1.456 1.456 0 012.08 0l1.165 1.165a1.456 1.456 0 010 2.08l-1.497 1.497c-.167 0-.333.083-.5.083zm-1.497-2.995l1.497 1.498 1.082-1.082a.253.253 0 000-.333l-1.165-1.164a.253.253 0 00-.333 0l-1.081 1.081z","fill":"#363636"}})])
          )
        }
      }
    